import {useIntl} from 'react-intl'

import {GENERAL_FORM_VALIDATION_MESSAGES as generalMessages} from '../../constants'
import useGlobalFields from '../../components/forms/useGlobalFields'

export default function useWithdrawalFields({form, prefix = ''}) {
    const {formatMessage} = useIntl()
    const {
        control,
        formState: {errors}
    } = form
    const {firstName, lastName, email} = useGlobalFields({form, prefix})
    const orderNumberLabel = formatMessage({
        defaultMessage: 'Order Number',
        id: 'global.order_number'
    })

    return {
        firstName,
        lastName,
        email,
        orderNumber: {
            name: `${prefix}orderNumber`,
            label: orderNumberLabel,
            type: 'text',
            defaultValue: '',
            inputProps: {
                autoComplete: 'off'
            },
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your order number.',
                    id: 'withdrawal.error.required_order_number'
                }),
                maxLength: {
                    message: formatMessage(generalMessages.maxLength, {
                        label: orderNumberLabel,
                        n: 50
                    }),
                    value: 50
                }
            },
            error: errors[`${prefix}orderNumber`],
            control
        }
    }
}
